export default "__VITE_ASSET__BCOBArcR__"